import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const maintenancePlanCodeSchema = surrealRecordSchema.extend({
  code: z.string(),
});

export type MaintenancePlanCode = z.infer<typeof maintenancePlanCodeSchema>;
